export const ADR_RISQUE = "ADR_RISQUE";
export const ADR_COMP = "ADR_COMP";
export const ADR_CODE_POSTAL = "ADR_CODE_POSTAL";
export const ADR_VILLE = "ADR_VILLE";
export const NATURE_LOG = "NATURE_LOG";
export const NATURE_OCCU = "NATURE_OCCU";
export const HAB_TYPE = "HAB_TYPE";
export const NBR_PIECES = "NBR_PIECES";
export const NBR_PIECES_40M2 = "NBR_PIECES_40M2";
export const ADR_ETAGE = "ADR_ETAGE";
export const SURFACE_DEP = "SURFACE_DEP";
export const POSSEDE_ENERGIEV = "POSSEDE_ENERGIEV";
export const POSSEDE_VERANDA = "POSSEDE_VERANDA";
export const POSSEDE_PISCINE = "POSSEDE_PISCINE";
export const REV_FISCAL = "REV_FISCAL";
export const TYPE_CH = "TYPE_CH";
export const NBR_COLOC = "NBR_COLOC";
export const NOM_BAILLEUR = "NOM_BAILLEUR";
export const TYPE_BAILLEUR = "TYPE_BAILLEUR";
export const FRANCHISE = "FRANCHISE";
